var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThumbUpIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3378_3294",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.0869141,
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3378_3294)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 21.0869H7V8.08691L14 1.08691L15.25 2.33691C15.3667 2.45358 15.4625 2.61191 15.5375 2.81191C15.6125 3.01191 15.65 3.20358 15.65 3.38691V3.73691L14.55 8.08691H21C21.5333 8.08691 22 8.28691 22.4 8.68691C22.8 9.08691 23 9.55358 23 10.0869V12.0869C23 12.2036 22.9833 12.3286 22.95 12.4619C22.9167 12.5952 22.8833 12.7202 22.85 12.8369L19.85 19.8869C19.7 20.2202 19.45 20.5036 19.1 20.7369C18.75 20.9702 18.3833 21.0869 18 21.0869ZM9 19.0869H18L21 12.0869V10.0869H12L13.35 4.58691L9 8.93691V19.0869ZM7 8.08691V10.0869H4V19.0869H7V21.0869H2V8.08691H7Z",
    fill: "#1C1B1F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThumbUpIcon);
export default __webpack_public_path__ + "static/media/thumb-up-icon.8d21e3b340cbbd059fd11cdcc06c360b.svg";
export { ForwardRef as ReactComponent };